import React from 'react';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

/**
 * Centers content with a consistent max width (`--container-max-width`,
 * default 1200px) and horizontal gutter. Use inside a `<section>` to keep
 * long-form or grid content readable on ultra-wide screens.
 */
const Container: React.FC<ContainerProps> = ({ className = '', children, ...rest }) => (
    <div className={['container', className].filter(Boolean).join(' ')} {...rest}>
        {children}
    </div>
);

export default Container;
